import React from 'react';

const journey = [
  {
    numeral: 'I',
    label: 'Drafting',
    note: 'The first pages are written in longhand—slow, deliberate, honest.',
    active: false,
  },
  {
    numeral: 'II',
    label: 'Revising',
    note: 'Where the story finds its true shape, one careful pass at a time.',
    active: true,
  },
  {
    numeral: 'III',
    label: 'On Its Way',
    note: 'Cover, title, and release details will be announced here first.',
    active: false,
  },
];

const ComingSoon: React.FC = () => {
  return (
    <section id="coming-soon" className="section">
      <div className="wrapper">
        <div className="section__header">
          <span className="eyebrow">Coming Soon</span>
          <h2 className="headline">The Next Novel Is Taking Shape</h2>
          <p className="lead">
            A new work of fiction is underway—a departure into new territory, written with the
            same unflinching attention to the bonds that hold us together. Here&apos;s a quiet
            glimpse while it finds its voice.
          </p>
        </div>

        <div className="surface">
          <div className="stack">
            <div className="journey">
              {journey.map((step) => (
                <div
                  key={step.label}
                  className={`journey__step${step.active ? ' journey__step--active' : ''}`}
                >
                  <p className="journey__numeral">{step.numeral}</p>
                  <p className="journey__label">{step.label}</p>
                  <p className="journey__note">{step.note}</p>
                </div>
              ))}
            </div>

            <div className="grid grid--two">
              <div className="stack">
                <span className="badge">What I Can Share</span>
                <p className="text-muted" style={{ margin: 0, fontSize: '1rem' }}>
                  <strong>A story unlike my first.</strong>
                  <br />
                  New genre, new ground—and the courage to begin again.
                </p>
              </div>
              <div className="stack">
                <span className="badge">What to Expect</span>
                <p className="text-muted" style={{ margin: 0 }}>
                  Characters tested by the world they inherit, and the quiet strength it takes
                  to remain tender inside it.
                </p>
              </div>
            </div>

            <div className="surface surface--subtle">
              <blockquote className="quote">
                “Every book asks a different question of its writer. This one is asking me for
                more courage than the last.”
                <small>Notebook entry · Draft Two</small>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
